export default __webpack_public_path__ + "static/media/salami.8f0783fd.png";